import React from 'react';
import './App.css';
import Header from './components/layout/Header';
import Hero from './components/sections/Hero';
import About from './components/sections/About';
import Services from './components/sections/Services';
import Technologies from './components/sections/Technologies';
import Team from './components/sections/Team';
import Contact from './components/sections/Contact';
import Footer from './components/layout/Footer';
import Projects from './components/sections/Projects';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Technologies />
        {/* <Team /> */}
        <Projects />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
